// services添加Record.js
// import store from '@/models/store'

// 定义操作类型数据
const operateTypes = [
  {
    type: 'create',
    name: '新增',
  },
  {
    type: 'delete',
    name: '删除',
  },
  {
    type: 'update',
    name: '修改',
  },
  {
    type: 'query',
    name: '查询',
  },
  {
    type: 'detail',
    name: '详情',
  },
  {
    type: 'import',
    name: '导入',
  },
  {
    type: 'export',
    name: '导出',
  },
]

/**
 * @description 记录操作日志
 * @param {type: string} 操作类型
 */
const recordOperation = ({ type }) => {
  // 获取currentTag信息，拿到当前模块名，【注意每个系统获取的方式可能不一样】
  // const { displayName } = store.getters['System/currentTag']
  // const { displayName } = JSON.parse(localStorage.getItem('vuex')).System.currentTag
  // const currentOperateType = _.find(operateTypes, { type })
  // 自定义axios头部参数
  // axios.defaults.headers.common.moduleName = encodeURIComponent(displayName)
  // axios.defaults.headers.common.operateName = encodeURIComponent(
  //   currentOperateType && currentOperateType.name
  // )
}

export default recordOperation
